import { ImageSegmentProps } from './props';
import { Segment } from './Segment';

const ImageSegment = (props: ImageSegmentProps) => <Segment {...props} />;

export { ImageSegment };
